export const SEARCH_IDS_SEPARATOR = ','
export const MAX_SEARCH_IDS = 50
export const MAX_SEARCH_ID_LENGTH = 50

export const parseSearchIds = (
  value: string = '',
  maxIds: number = MAX_SEARCH_IDS,
  maxIdLength: number = MAX_SEARCH_ID_LENGTH
): string[] =>
  Array.from(
    new Set(
      value
        .split(SEARCH_IDS_SEPARATOR)
        .map((part) => part.trim().slice(0, maxIdLength))
        .filter(Boolean)
    )
  ).slice(0, maxIds)
